<template>
  <section v-if="show && backUrl" :class="['outcode-backbtn', backBtnClass]">
    <span class="btn-back" @click="back" />
    <span class="hide" @click="hide" />
  </section>
</template>

<script>
import { outcodeHandler } from '@/utils/outcodeHandler'
import pwaGlobalConfig from '@/utils/pwaGlobalConfig'
import tjAppHelper from '@lib/business/tjAppHelper'

export default {
  data() {
    return {
      show: false,
      backUrl: '', // 点击返回url
      backBtnClass: '', // 样式
      outcode: ''
    }
  },
  created() {
    // api level > 351 才能回退到小红书
    if (tjAppHelper.getAppVersion() > 351) {
      this.initPage()
    }
  },
  methods: {
    initPage() {
      this.outcode = outcodeHandler(this.$route.query)
      // 小红书
      const isXHSReg = /^tujia_xhs_/
      if (this.outcode && isXHSReg.test(this.outcode) && process.env.VUE_APP_LOCAL === 'T') {
        this.initXHSBackBtn()
      }
    },
    initXHSBackBtn() {
      const { xhsBackURL } = this.$route.query
      this.backUrl = xhsBackURL
      this.backBtnClass = 'xhs'
      this.show = true
    },
    back() {
      try {
        if (pwaGlobalConfig.env.isTujiaApp) {
          window.tjBridge.sendScheme({
            scheme: this.backUrl,
            success: () => {
            },
            fail: () => {
            },
            final: () => { }
          })
        } else {
          window.location.href = this.backUrl
        }
      } catch (e) { }
      this.report('C_redapp_hd_back_act')
    },
    hide() {
      this.show = false
      this.report('C_HIDE')
    },
    report(eventname, ext = {}) {
      window._fas && window._fas.setCustomTrack({
        eventname,
        ext: {
          backUrl: this.backUrl,
          clickId: this.outcode,
          ...ext
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.outcode-backbtn {
  position: fixed;
  left: 0;
  bottom: 60px;
  display: flex;
  flex-direction: row;
  width: 125px;
  height: 36px;
  z-index: 10;
  margin-bottom: constant(safe-area-inset-bottom);
  margin-bottom: env(safe-area-inset-bottom);
  &.xhs {
    background-image: url('https://pic.tujia.com/upload/festatic/2407/38ac7a04b712c4eb.png');
    background-repeat: no-repeat;
    background-size: 100%;
  }
  .btn-back {
    flex: 1;
  }
  .hide {
    width: 33px;
  }
}
</style>
